import logger from './logger'

export class CustomError extends Error {
  constructor(errorName, options = {}, defaultOptions = {}) {
    super()
    this.name = errorName
    this.status = options.status || defaultOptions.status || 400
    this.message = options.message || defaultOptions.message || 'Custom Error'
    this.detail = options.detail || defaultOptions.detail || ''

    Error.captureStackTrace(this, this.constructor)
  }

  toResponseObject() {
    return {
      status: this.status,
      name: this.name,
      message: this.message,
      detail: this.detail,
      stack: this.stack,
    }
  }
}

function createError(errorName, defaultValues) {
  return (options) => {
    if (typeof options === 'string') {
      return new CustomError(errorName, { message: options }, defaultValues)
    }
    return new CustomError(errorName, options, defaultValues)
  }
}

export const testCustomError = createError('testCustomError', {
  status: 400,
  message: 'Defaultní text testovacího erroru',
  detail: 'detail erroru',
})

export const badRequest = createError('BadRequest', {
  message: 'Bad Request',
})

export const invalidAccessData = createError('InvalidAccessData', {

})

export const tokenIsRequired = createError('TokenIsExpired', {
  message: 'access token is required',
})

export const tokenIsExpired = createError('TokenIsExpired', {
  message: 'access token is expired',
})

export const restrictedArea = createError('RestrictedArea', {
  message: 'Restricted Area. Access token needed',
})

export const invalidLoginData = createError('InvalidLoginData', {
  message: 'Nesprávne údaje',
})

export const invalidPassword = createError('invalidPassword', {
  message: 'Invalid password',
})

export const invalidFormData = createError('InvalidFormData', {})

export const emailIsUsed = createError('EmailIsUsed', {
  message: 'This email is already used. Please take another.',
  status: 409,
})

export const resetPossibleOnceADay = createError('ResetPossibleOnceADay', {
  message: 'You already reseted your password today',
})

export const userNotFound = createError('UserNotFound', {
  status: 404,
  message: 'User could not be found',
})



// WEBPACK FOOTER //
// ./src/server/lib/errors.js